export default __webpack_public_path__ + "static/0066-09a25333fb4efe7eb74fe816362ab792.png";